<template>
  <div>
    <Header />

    <div
      style="
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      "
    >
      <v-container>
        <v-card class="elevation-2 rounded-lg" width="450">
          <v-card-text class="pa-8">
            <h2 class="text-center mb-6">
              <span class="font-weight-light"> Welcome to the </span>
              SRS Web App
            </h2>

            <v-text-field
              :disabled="isAuthenticating"
              prepend-inner-icon="mdi-email"
              placeholder="example@address.com"
              type="email"
              v-model="email"
              @keyup.enter="onEnterKeyPressed"
            >
            </v-text-field>

            <v-text-field
              class="mb-4"
              :disabled="isAuthenticating"
              prepend-inner-icon="mdi-lock"
              placeholder="******"
              type="password"
              v-model="password"
              @keyup.up="onEnterKeyPressed"
            >
            </v-text-field>

            <v-btn
              color="secondary"
              :disabled="!isCredentialsValid || isAuthenticating"
              :loading="isAuthenticating"
              block
              class="font-weight-regular text-capitalize px-16"
              @click="onSignInClicked"
            >
              Sign In
            </v-btn>

            <p class="mt-5 text-center">
              <strong
                class="blue--text"
                style="cursor: pointer; text-decoration: underline"
                @click="onForgetPasswordsClicked"
              >
                Forgot your password?
              </strong>
            </p>
          </v-card-text>
        </v-card>
        <div v-if="isDevelopmentMode" class="mt-6">
          <p
            class="text-center"
            :class="{
              'blue--text': isCredentialsValid,
              'gray--text': !isCredentialsValid,
            }"
          ></p>

          <p v-for="(item, index) of logins" :key="index" class="text-center">
            <strong
              class="blue--text"
              style="cursor: pointer; text-decoration: underline"
              @click="onLoginAsClicked(item.email, item.password)"
              >Login as {{ item.email }}</strong
            >
          </p>
        </div>
      </v-container>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import api from "../api";
import environment from "../environment";
import toasts from "../utils/toasts";

export default {
  data: () => ({
    email: "",
    password: "",
    isAuthenticating: false,
    loading: false,

    logins: [
      {
        email: "manager@vip.com",
        password: "Pelos1",
      },
      {
        email: "Rafael.Loustaunau@lnfdist.com",
        password: "Bus1@",
      },
      {
        email: "Pablo@DessauSoftware.com",
        password: "Bus1@",
      },
      {
        email: "Jesus@DessauSoftware.com",
        password: "Bus1@",
      },
      {
        email: "Emily.Luevano@LnfDist.com",
        password: "Bus1@",
      },
    ],
  }), // data

  computed: {
    isCredentialsValid() {
      if (
        this.email == undefined ||
        this.email == null ||
        this.email.trim().length == 0
      )
        return false;

      if (
        this.password == undefined ||
        this.password == null ||
        this.password.trim().length == 0
      )
        return false;

      return true;
    },

    isDevelopmentMode() {
      return environment.isDevelopmentMode;
    },
  }, // computed

  methods: {
    async authenticate() {
      this.isAuthenticating = true;

      try {
        await api.auth.authenticate({
          email: this.email,
          password: this.password,
        });

        this.$router.push("/app/reports");
      } catch (error) {
        if (error.response && error.response.data)
          toasts.error(error.response.data.message);
        else toasts.error(error);
      } finally {
        this.isAuthenticating = false;
      }
    },

    async onCreateAccountClicked() {
      if (!this.isCredentialsValid) return;

      this.isAuthenticating = true;

      try {
        await api.users.signUp({
          email: this.email,
          guiPassword: this.password,
        });

        this.authenticate();
      } catch (error) {
        if (error.response && error.response.data)
          toasts.error(error.response.data.message);
        else toasts.error(error);
      } finally {
        this.isAuthenticating = false;
      }
    },

    onEnterKeyPressed() {
      return; // TODO This prevents the sign out loop

      if (!this.isCredentialsValid) return;

      this.authenticate();
    },

    onLoginAsClicked(email, password) {
      this.email = email;
      this.password = password;
      this.authenticate();
    },
    onSignInClicked() {
      this.authenticate();
    },

    onForgetPasswordsClicked() {
      this.$router.push("/resetPassword");
    },
  }, // methods
};
</script>

<style>
</style>